
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security/storage",
      function () {
        return require("private-next-pages/security/storage.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security/storage"])
      });
    }
  